import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [
    "modal", "modalDateLbl", "modalDoctorCostLbl", "modalEstimateCostLbl",
    "modalInsertionDate", "modalDoctorCost", "modalEstimateCost", "modalImages",
    "modalSaveBtn", "tooth", "spinner", "lock", "doctorCostField", "doctorProcBtn", "collapse",
    "proceduresAccordion", "oldProceduresCarousel", "noProceduresMessage"
  ]

  connect() {
    console.log('🔄 Insertion Controller v2.2 - FIXED defaultPrice in getProcedureInsurtionImages')
    this.isSaving = false
    this.currentTeethNo = null

    // Initialize autocomplete if needed - keep jQuery for autocomplete for now as migrating it fully is large
    this.initAutocomplete()
  }

  initAutocomplete() {
    if ($("#procedures_insurtions_tags").length > 0) {
      $("#procedures_insurtions_tags").autocomplete({
        source: (request, response) => {
          $.ajax({
            url: "/admin/doctors/autocomplete",
            dataType: 'json',
            data: { query: request.term, insured_number: gon.insured_number, locale: gon.locale },
            success: (data) => {
              response($.map(data, (value, key) => {
                return { label: value.label, value: value.value, key: value.key };
              }));
            }
          });
        },
        select: (event, ui) => {
          event.target.value = ui.item.label;
          $('#procedures_insurtions_doctor_email').val(ui.item.key);
          $('#procedures_insurtions_doctor_name').val(ui.item.label);

          if (this.hasProceduresAccordionTarget) {
            this.proceduresAccordionTarget.style.display = "inline"
          } else {
            $('#procedures_accordion').css("display", "inline");
          }

          $('#doctor_email').val(gon.doctor_id);
          $('#doctor_name').val(gon.doctor_name);
          $('#locale').val(gon.locale);
          $('#insured_number').val(gon.insured_number);

          return false;
        }
      });
    }
  }

  selectTeeth(event) {
    if (event.preventDefault) event.preventDefault()

    const data = event.params || {}
    // Handle direct call from checkApprovalStatus
    console.log('selectTeeth data:', data)
    const no = data.no
    const procId = data.procId
    const isAttached = data.isAttached

    const toothElement = event.currentTarget
    const coloredElement = toothElement.querySelector('.color') || toothElement.querySelector('.black-white')

    // If called from mock event, coloredElement might be different or already updated
    const isColored = coloredElement ? coloredElement.classList.contains('color') : false

    // Check if locked
    const lockIcon = toothElement.querySelector(`.lock-proc-${no}`)
    const isLocked = gon.user_type === 'doctor' && lockIcon && lockIcon.style.display !== 'none' && !isColored

    const idsData = no.split("_")

    // Always check for history first
    this.checkAndShowHistoryTab(idsData[1], idsData[0], (showHistoryTab, historyData) => {
      // Prepare labels
      const labels = {
        date: data.dateLbl || (gon && gon.insertion_date) || 'Insertion date',
        estimateCost: data.estimateCostLbl || (gon && gon.estimate_cost) || 'Estimate cost',
        cancel: data.cancelLbl || (gon && gon.cancel) || 'Cancel',
        confirm: data.confirmLbl || (gon && gon.save_label) || 'Save',
        doctorCost: data.doctorCostLbl || (gon && gon.one_teeth_require) || 'Doctor cost',
        errMsg: data.errMsg || (gon && gon.empty_fields) || 'Please fill all the required fields'
      }

      const defaultPrice = parseFloat(data.defaultPrice) || 0
      const coverageRate = parseFloat(data.coverageRate) || 0

      // Auto-fill estimate cost with default price if not set
      const validDefaultPrice = !isNaN(defaultPrice) ? defaultPrice : ''
      const estimateCost = data.estimateCost || validDefaultPrice

      let doctorCost = data.doctorCost || validDefaultPrice
      const oldProc = data.oldProc || ["---"]
      const history = data.history || ""
      const insertionDate = data.insertionDate || ''
      const isBlocked = data.isBlocked || false

      if (showHistoryTab) {
        // History exists or blocked+approved -> Show modal with history
        if (!this.isSaving) {
          this.isSaving = true

          const handleSave = (result) => {
            this.isSaving = false
            this.addInsuredProcedure(idsData, procId, result)
          }

          // First time clicking this tooth - track it and show loading
          this.currentTeethNo = no

          // Show spinner
          const spinner = document.querySelector(`.spinner-proc-${no}`)
          if (spinner) spinner.style.display = "inline"

          // Add color class
          if (coloredElement) {
            coloredElement.classList.add("color")
            coloredElement.classList.remove("black-white")
          }

          // Auto-fill for doctor
          if (gon.user_type === 'doctor') {
            doctorCost = defaultPrice
          }

          // Check if images are required and we have a valid procedure ID
          const requiresImages = (isAttached === true || isAttached === 'true')
          // For new insertions, use today's date from server
          const historyInsertionDate = insertionDate || gon.today_date || ''
          if (requiresImages && procId != -1 && procId != "-1") {
            this.getProcedureInsurtionImages(no, procId, labels, historyInsertionDate, doctorCost, estimateCost, coverageRate, defaultPrice, isBlocked, requiresImages, true, historyData)
          } else {
            this.setInsuredProcedure(no, procId, labels, oldProc, history, doctorCost, doctorCost, coverageRate, defaultPrice, historyInsertionDate, isAttached, handleSave, { showHistoryTab: true, historyData: historyData })
          }
        }
      } else {
        if (isLocked) {
          // Locked and no history/approval -> Show alert
          Swal.fire({
            icon: 'info',
            title: 'Locked',
            text: 'Please request permission to edit this tooth.', // Using English fallback, should use translation
            confirmButtonText: 'OK'
          })
        } else {
          // Unlocked and no history -> Show normal modal
          if (!this.isSaving) {
            this.isSaving = true

            const handleSave = (result) => {
              this.isSaving = false
              this.addInsuredProcedure(idsData, procId, result)
            }

            if (!isColored) {
              // First time clicking this tooth - track it and show loading
              this.currentTeethNo = no

              // Show spinner
              const spinner = document.querySelector(`.spinner-proc-${no}`)
              if (spinner) spinner.style.display = "inline"

              // Add color class
              if (coloredElement) {
                coloredElement.classList.add("color")
                coloredElement.classList.remove("black-white")
              }

              // Auto-fill for doctor
              if (gon.user_type === 'doctor') {
                doctorCost = defaultPrice
              }

              // For new insertions, use today's date from server
              const newInsertionDate = insertionDate || gon.today_date || ''

              this.setInsuredProcedure(no, procId, labels, oldProc, history, doctorCost, doctorCost, coverageRate, defaultPrice, newInsertionDate, isAttached, handleSave, { showHistoryTab: false })
            } else {
              // Already colored (editing existing?) - usually this goes to deleteConfirmedProcedure but just in case
              this.setInsuredProcedure(no, procId, labels, oldProc, history, doctorCost, estimateCost, coverageRate, defaultPrice, insertionDate, isAttached, handleSave, { showHistoryTab: false })
            }
          }
        }
      }
    })
  }

  setInsuredProcedure(id, procId, labels, oldProc, history, doctorCost, estimateCost, coverageRate, defaultPrice, insertionDate, isAttached = false, handleSaveOverride = null, preCheckResult = null) {
    const idsData = id.split("_")
    const teethPos = idsData[0]
    const procCode = idsData[1]

    console.log('Extracted from id:', { teethPos, procCode, idsData })

    // Check if this is a new insertion (procId is -1 or "-1")
    const isNewInsertion = (procId === -1 || procId === "-1")
    
    // For new insertions, use today's date from server
    if (isNewInsertion && !insertionDate) {
      insertionDate = gon.today_date || ''
    }

    // Check if procedure requires images
    const requiresImages = (isAttached === true || isAttached === 'true')

    // For new procedures with images, show a placeholder upload button
    let imagesHtml = ''
    if (requiresImages) {
      imagesHtml = `<div class="alert alert-info text-center">
        <i class="fe fe-info mr-2"></i>
        ${gon.locale === 'ar' ? 'سيتم تفعيل رفع الصور بعد حفظ الإجراء' : 'Image upload will be available after saving the procedure'}
      </div>`
    }

    const openModalCallback = (showHistoryTab, historyData) => {
      console.log('=== checkAndShowHistoryTab CALLBACK ===')
      console.log('showHistoryTab:', showHistoryTab)
      console.log('historyData:', historyData)
      this.showProcedureModal({
        dateLabel: labels.date || (gon && gon.insertion_date),
        doctorCostLabel: labels.doctorCost || (gon && gon.one_teeth_require),
        estimateCostLabel: labels.estimateCost || (gon && gon.estimate_cost),
        insurtionDate: insertionDate || '',
        doctorCost: doctorCost, // Pass the auto-filled cost
        estimateCost: estimateCost,
        imagesHtml: imagesHtml, // Show placeholder for procedures with images
        coverageRate: coverageRate,
        defaultPrice: defaultPrice,
        isBlocked: false, // New procedures are not blocked
        disableAllFields: false,
        showSaveButton: true,
        showHistoryTab: showHistoryTab,
        procedureCode: procCode,
        teethPosition: teethPos,
        historyData: historyData,
        isNewInsertion: isNewInsertion,
        onSave: (result) => {
          const costInput = document.getElementById(`cost_proc_${idsData[1]}`)
          if (costInput) {
            costInput.classList.remove("bg-danger-light")
            costInput.classList.remove("border-danger")
          }

          let estimateCost = 0
          let approvalStatus = false

          if (result.value.estimateCost !== "") {
            estimateCost = result.value.estimateCost
            approvalStatus = true
          }

          $.ajax({
            type: "post",
            url: "/admin/procedures/insertion/add",
            dataType: "json",
            beforeSend: (xhr) => { xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content')) },
            data: {
              insured_number: gon.insured_number,
              doctor_id: gon.doctor_id,
              doctor_cost: result.value.doctorCost,
              estimate_cost: estimateCost,
              procedure_code: idsData[1],
              status: true,
              teeth_position: idsData[0],
              procedure_id: procId,
              approval_status: approvalStatus,
              insurtion_date: result.value.insurtionDate,
              locale: gon.locale,
              force_add: (procId === -1 || procId === "-1")
            },
            success: (resp) => {
              this.isSaving = false
              const spinner = document.querySelector(`.spinner-proc-${id}`)
              if (spinner) spinner.style.display = "none"

              if (resp.success) {
                if (costInput) costInput.disabled = true

                // Update link attributes
                const link = document.querySelector(`.link_${id}`)
                if (link) {
                  // Update action to deleteConfirmedProcedure to enable history fetching
                  link.setAttribute('data-action', 'click->insertion#deleteConfirmedProcedure')

                  // Set params for deleteConfirmedProcedure
                  link.dataset.insertionInsurtionIdParam = resp.id
                  link.dataset.insertionProcIdParam = idsData[1] // Procedure Code
                  link.dataset.insertionTeethPosParam = idsData[0] // Teeth Pos

                  link.dataset.insertionIsAttachedParam = resp.is_with_image
                  link.dataset.insertionInsertionDateParam = resp.insurtion_date
                  link.dataset.insertionDoctorCostParam = resp.doctor_cost
                  link.dataset.insertionEstimateCostParam = resp.estimate_cost
                  link.dataset.insertionCoverageRateParam = coverageRate
                  link.dataset.insertionDefaultPriceParam = defaultPrice
                  link.dataset.insertionIsBlockedParam = resp.is_blocked
                }


                const docProcBtn = document.getElementById(`doctor_proc_${resp.procedure_id}`)
                const collapse = document.getElementById(`collapse_${idsData[1]}`)

                if (docProcBtn && collapse) {
                  const count = collapse.querySelectorAll('.color').length
                  docProcBtn.value = `${resp.label} (${count})`
                  docProcBtn.disabled = false
                }

                // Add procedure card to old procedures carousel
                if (resp.procedure_card_html) {
                  this.addProcedureToCarousel(resp.procedure_card_html)
                }

                // Show success message
                const successMessage = gon.locale === 'ar' ? 'تم إضافة الإجراء بنجاح' : 'Procedure added successfully'
                Swal.fire({
                  position: 'top-end',
                  icon: 'success',
                  title: successMessage,
                  showConfirmButton: false,
                  timer: 1500
                }).then(() => {
                  if (resp.is_with_image) {
                    this.swalUploadImage(resp.upload_title, resp.upload_msg, resp.id, idsData[1], idsData[0], resp.upload_before, resp.upload_after, resp.upload, resp.approval_new_cancel)
                  }
                })

                // Show lock icon for blocked procedures
                if (resp.is_blocked) {
                  const lock = document.querySelector(`.lock-proc-${idsData[0]}_${idsData[1]}`)
                  if (lock) {
                    lock.style.display = ''
                    lock.innerHTML = '<h1 style="color: brown;filter: drop-shadow(1px -1px 0px black);"><i class="fe fe-lock"></i></h1>'
                  }
                }

                if (approvalStatus) {
                  if (collapse) {
                    const nextSpan = collapse.querySelector('.color + span')
                    if (nextSpan) nextSpan.style.display = "block"
                  }

                  if (link) {
                    link.setAttribute('data-action', 'click->insertion#deleteConfirmedProcedure')
                    link.dataset.insertionInsurtionIdParam = resp.id
                  }
                }
              } else {
                // Revert
                const link = document.querySelector(`.link_${id}`)
                if (link) {
                  const colored = link.querySelector('.color')
                  if (colored) {
                    colored.classList.add("black-white")
                    colored.classList.remove("color")
                  }
                }

                Swal.fire({
                  title: resp.title,
                  html: resp.msg,
                  icon: 'warning',
                  showCancelButton: false,
                  confirmButtonColor: '#3085d6',
                  confirmButtonText: resp.confirm
                })
              }
            }
          })
        }
      })
    }

    if (preCheckResult) {
      openModalCallback(preCheckResult.showHistoryTab, preCheckResult.historyData)
    } else {
      // Check if procedure is blocked and has approved approval - if so, show history tab
      this.checkAndShowHistoryTab(procCode, teethPos, openModalCallback)
    }
  }

  checkAndShowHistoryTab(procedureCode, teethPosition, callback) {
    // Check if procedure is blocked and has approved approval
    // For doctors, use gon.doctor_id; for admins, try form fields
    let doctorId = gon.doctor_id
    if (!doctorId && gon.user_type === 'doctor') {
      // For doctors, doctor_id should be set in gon, but fallback to current_doctor if available
      doctorId = gon.doctor_id || $('#procedures_insurtions_doctor_email').val() || $('#doctor_email').val()
    } else if (!doctorId && gon.user_type === 'admin') {
      // For admins, try form fields
      doctorId = $('#procedures_insurtions_doctor_email').val() || $('#doctor_email').val()
    }

    console.log('checkAndShowHistoryTab called with:', {
      procedureCode,
      teethPosition,
      insured_number: gon.insured_number,
      doctor_id: doctorId,
      gon_doctor_id: gon.doctor_id,
      gon_user_type: gon.user_type,
      form_doctor_email: $('#procedures_insurtions_doctor_email').val(),
      form_doctor_email_2: $('#doctor_email').val()
    })

    if (!procedureCode || !teethPosition || !gon.insured_number) {
      console.error('Missing required parameters for history check', {
        procedureCode,
        teethPosition,
        insured_number: gon.insured_number
      })
      if (callback) {
        callback(false, [])
      }
      return
    }

    $.ajax({
      type: "get",
      url: "/admin/procedures/get/history",
      dataType: "json",
      beforeSend: (xhr) => {
        xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))
        console.log('Sending AJAX request to /admin/procedures/get/history')
      },
      data: {
        insured_number: gon.insured_number,
        procedure_code: procedureCode,
        teeth_position: teethPosition,
        doctor_id: doctorId,
        locale: gon.locale
      },
      success: (result) => {
        console.log('AJAX success - full result:', result)
        // Show history tab only if procedure is blocked AND has approved approval
        const showHistoryTab = result.success && result.show_history_tab === true
        console.log('History check result:', {
          success: result.success,
          show_history_tab: result.show_history_tab,
          is_blocked: result.is_blocked,
          has_approved_approval: result.has_approved_approval,
          history_count: result.history ? result.history.length : 0,
          willShowTab: showHistoryTab
        })
        if (callback) {
          console.log('Calling callback with showHistoryTab:', showHistoryTab)
          callback(showHistoryTab, result.history || [])
        } else {
          console.error('No callback provided to checkAndShowHistoryTab')
        }
      },
      error: (xhr, status, error) => {
        console.error('AJAX error:', {
          status: status,
          error: error,
          responseText: xhr.responseText,
          statusCode: xhr.status
        })
        // On error, don't show history tab
        if (callback) {
          callback(false, [])
        }
      }
    })
  }

  updateInsuredProcedure(procId, result) {
    let estimateCost = 0
    let approvalStatus = false

    if (result.value.estimateCost !== "") {
      estimateCost = result.value.estimateCost
      approvalStatus = true
    }

    $.ajax({
      type: "put",
      url: "/admin/procedures/insertion/update",
      dataType: "json",
      beforeSend: (xhr) => { xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content')) },
      data: {
        doctor_cost: result.value.doctorCost,
        estimate_cost: estimateCost,
        procedure_id: procId,
        approval_status: approvalStatus,
        insurtion_date: result.value.insurtionDate,
        locale: gon.locale
      },
      success: (resp) => {
        if (resp.success) {
          // Update procedure card in carousel
          if (resp.procedure_card_html) {
            this.updateProcedureInCarousel(procId, resp.procedure_card_html)
          }

          // Show success message
          const successMessage = gon.locale === 'ar' ? 'تم تحديث الإجراء بنجاح' : 'Procedure updated successfully'
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: successMessage,
            showConfirmButton: false,
            timer: 1500
          })
        }
      },
      error: () => {
        const errorMessage = gon.locale === 'ar' ? 'حدث خطأ أثناء التحديث' : 'Error updating procedure'
        Swal.fire({
          icon: 'error',
          title: errorMessage,
          showConfirmButton: true
        })
      }
    })
  }

  getProcedureInsurtionImages(no, procId, labels, insertionDate, doctorCost, estimateCost, coverageRate, defaultPrice, isBlocked, isAttached = false, showHistoryTab = false, historyData = undefined) {
    // Extract teeth position and procedure code from 'no' parameter (format: teethPos_procCode)
    const noData = no.split("_")
    const teethPos = noData[0]
    const procCode = noData[1]

    $.ajax({
      type: "get",
      url: "/admin/procedures/get/uploaded_images",
      dataType: "json",
      beforeSend: (xhr) => { xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content')) },
      data: {
        procedure_id: procId,
        doctor_id: gon.doctor_id,
        locale: gon.locale
      },
      success: (result) => {
        if (result.success) {
          if (result.id == -1) {
            this.setInsuredProcedure(no, procId, labels, [], "", "", "", coverageRate, defaultPrice, insertionDate, isAttached, null, { showHistoryTab: showHistoryTab, historyData: historyData })
          } else {
            this.isSaving = false
            const deleteMsg = (gon && gon.delete_msg) ? gon.delete_msg : ''
            const firstImg = result.first_image && result.first_image !== '' ? result.first_image : '/assets/xray.jpg'
            const secondImg = result.second_image && result.second_image !== '' ? result.second_image : '/assets/xray.jpg'

            // Check if current doctor is the creator of this procedure
            const isCreator = result.doctor_id && gon.doctor_id && result.doctor_id === gon.doctor_id
            
            // Determine actual blocked status from API response (more reliable than passed parameter)
            const actualIsBlocked = result.is_blocked || false

            const imagesHtml = `<div class="row mb-3">
              <div class="col-6 d-flex"><div class="card flex-fill"><img alt="Card Image" src="${firstImg}" class="card-img-top" style="max-height: 200px; object-fit: contain;" onerror="this.src='/assets/xray.jpg'"><div class="card-header"><h5 class="card-title mb-0">${result.first_image_title}</h5></div></div></div>
              <div class="col-6 d-flex"><div class="card flex-fill"><img alt="Card Image" src="${secondImg}" class="card-img-top" style="max-height: 200px; object-fit: contain;" onerror="this.src='/assets/xray.jpg'"><div class="card-header"><h5 class="card-title mb-0">${result.second_image_title}</h5></div></div></div>
              </div>
              <button type="button" data-action="click->insertion#triggerUpload" data-upload-title="${result.upload_title}" data-upload-msg="${result.upload_msg}" data-proc-id="${result.id}" data-proc-code="${procCode}" data-teeth-pos="${teethPos}" data-upload-before="${result.upload_before}" data-upload-after="${result.upload_after}" data-upload-btn="${result.upload}" data-cancel-btn="${result.approval_new_cancel}" class="btn btn-info mt-2 mb-3">${result.upload}</button>
              <div></div>`

            // Extract procedure code and teeth position for history check
            const noData = no.split("_")
            const teethPosForHistory = noData[0]
            const procCodeForHistory = noData[1]

            const handleShowModal = (showHistoryTabVal, historyDataVal) => {
              // For doctors viewing existing procedures (not new)
              const isDoctor = gon.user_type === 'doctor'
              const isExistingProcedure = procId && procId !== -1 && procId !== "-1"
              
              // Doctors viewing existing procedures: disable all fields except image upload for creator
              const shouldDisableAllFields = actualIsBlocked || (isDoctor && isExistingProcedure)
              const shouldShowSaveButton = !actualIsBlocked && !(isDoctor && isExistingProcedure)
              const shouldAllowImagesOnly = (actualIsBlocked && isCreator) || (isDoctor && isExistingProcedure && isCreator)
              
              this.showProcedureModal({
                dateLabel: labels.date,
                doctorCostLabel: labels.doctorCost,
                estimateCostLabel: labels.estimateCost,
                insurtionDate: result.insurtion_date || insertionDate,
                doctorCost: result.doctor_cost || doctorCost,
                estimateCost: result.estimate_cost || estimateCost,
                imagesHtml: imagesHtml,
                coverageRate: coverageRate,
                defaultPrice: defaultPrice,
                isBlocked: actualIsBlocked,
                disableAllFields: shouldDisableAllFields,
                allowImagesOnly: shouldAllowImagesOnly,
                showSaveButton: shouldShowSaveButton,
                showHistoryTab: showHistoryTabVal,
                procedureCode: procCodeForHistory,
                teethPosition: teethPosForHistory,
                historyData: historyDataVal,
                showAddNewButton: true,
                isAttached: isAttached,
                onSave: (resultdata) => {
                  this.isSaving = false
                  this.updateInsuredProcedure(procId, resultdata)
                }
              })
            }

            // Check if historyData is already provided (from deleteConfirmedProcedure or selectTeeth)
            if (historyData !== undefined) {
              handleShowModal(showHistoryTab, historyData)
            } else {
              // Otherwise fetch it
              this.checkAndShowHistoryTab(procCodeForHistory, teethPosForHistory, handleShowModal)
            }
          }
        } else {
          this.isSaving = false
        }
      },
      error: () => {
        this.isSaving = false
        if (procId == -1) {
          this.setInsuredProcedure(no, procId, labels, [], "", "", "", coverageRate, defaultPrice, insertionDate, isAttached, null, { showHistoryTab: showHistoryTab, historyData: historyData })
        }
      }
    })
  }

  triggerUpload(event) {
    event.preventDefault()
    event.stopPropagation()
    const d = event.currentTarget.dataset
    this.swalUploadImage(d.uploadTitle, d.uploadMsg, d.procId, d.procCode, d.teethPos, d.uploadBefore, d.uploadAfter, d.uploadBtn, d.cancelBtn)
  }

  swalUploadImage(uploadTitle, uploadMsg, id, procCode, teethPos, uploadBefore, uploadAfter, upload, approvalNewCancel) {
    Swal.fire({
      title: uploadTitle,
      html: `<div style="overflow-x: hidden;">${uploadMsg}<input type='hidden' value='${id}' id='swal_proc_id'><div class='form-group row'><label class='col-form-label col-12 col-md-4 mt-2'>${uploadBefore}</label><div class='col-12 col-md-8'><input class='swal2-file form-control mb-2' id='first_file' accept='image/*' type='file'></div></div><div class='form-group row'><label class='col-form-label col-12 col-md-4 mt-2'>${uploadAfter}</label><div class='col-12 col-md-8'><input id='second_file' accept='image/*' class='swal2-file form-control' type='file'></div></div></div>`,
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonText: upload,
      cancelButtonText: approvalNewCancel
    }).then((file) => {
      if (file.value) {
        var formData = new FormData();
        var first_file = $('.swal2-file')[0].files[0];
        var second_file = $('.swal2-file')[1].files[0];
        formData.append("first_file", first_file);
        formData.append("second_file", second_file);
        formData.append("proc_id", document.getElementById('swal_proc_id').value);

        $.ajax({
          headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') },
          method: 'post',
          url: '/admin/procedures/insertion/upload_procedure_images',
          data: formData,
          processData: false,
          contentType: false,
          success: (resp) => {
            const uploadSuccessMsg = gon.locale === 'ar' ? 'تم رفع الصور بنجاح' : 'Images uploaded successfully'
            
            // Fetch updated images from server to get new blob URLs
            $.ajax({
              type: "get",
              url: "/admin/procedures/get/uploaded_images",
              dataType: "json",
              beforeSend: (xhr) => { xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content')) },
              data: {
                procedure_id: id,
                doctor_id: gon.doctor_id,
                locale: gon.locale
              },
              success: (result) => {
                if (result.success && result.id != -1) {
                  // Update the images in the modal with new URLs
                  const firstImg = result.first_image && result.first_image !== '' ? result.first_image : '/assets/xray.jpg'
                  const secondImg = result.second_image && result.second_image !== '' ? result.second_image : '/assets/xray.jpg'
                  
                  const imagesHtml = `<div class="row mb-3">
                    <div class="col-6 d-flex"><div class="card flex-fill"><img alt="Card Image" src="${firstImg}" class="card-img-top" style="max-height: 200px; object-fit: contain;" onerror="this.src='/assets/xray.jpg'"><div class="card-header"><h5 class="card-title mb-0">${result.first_image_title}</h5></div></div></div>
                    <div class="col-6 d-flex"><div class="card flex-fill"><img alt="Card Image" src="${secondImg}" class="card-img-top" style="max-height: 200px; object-fit: contain;" onerror="this.src='/assets/xray.jpg'"><div class="card-header"><h5 class="card-title mb-0">${result.second_image_title}</h5></div></div></div>
                    </div>
                    <button type="button" data-action="click->insertion#triggerUpload" data-upload-title="${result.upload_title}" data-upload-msg="${result.upload_msg}" data-proc-id="${result.id}" data-proc-code="${procCode}" data-teeth-pos="${teethPos}" data-upload-before="${result.upload_before}" data-upload-after="${result.upload_after}" data-upload-btn="${result.upload}" data-cancel-btn="${result.approval_new_cancel}" class="btn btn-info mt-2 mb-3">${result.upload}</button>
                    <div></div>`
                  
                  $('#procedure_modal_images').html(imagesHtml)
                }
              }
            })
            
            Swal.fire({
              position: 'top-end',
              icon: 'success',
              title: uploadSuccessMsg,
              showConfirmButton: false,
              timer: 1800
            })
          },
          error: () => {
            Swal.fire({ type: 'error', title: 'Oops...', text: 'Something went wrong!' })
          }
        })
      }
    })
  }

  showProcedureModal(options) {
    const { dateLabel, doctorCostLabel, estimateCostLabel, insurtionDate, doctorCost, estimateCost, imagesHtml, coverageRate, defaultPrice, isBlocked, disableAllFields, allowImagesOnly, showSaveButton, onSave, showHistoryTab, procedureCode, teethPosition, historyData, showAddNewButton, isAttached, approvalStatus, isNewInsertion } = options

    // Show/hide tabs based on showHistoryTab flag
    console.log('showProcedureModal called with:', {
      showHistoryTab: showHistoryTab,
      procedureCode: procedureCode,
      teethPosition: teethPosition,
      historyData: historyData,
      historyDataLength: historyData ? historyData.length : 0,
      allOptions: options
    })

    if (showHistoryTab && procedureCode && teethPosition) {
      console.log('Showing history tab - conditions met, setting display to flex')
      $('#procedure_modal_tabs').show().css('display', 'flex')
      // Load history immediately if data is available, otherwise show empty state
      if (historyData && historyData.length > 0) {
        this.loadProcedureHistory(procedureCode, teethPosition, historyData)
      } else {
        // Show empty state if no history yet
        $('#procedure_history_data').hide()
        $('#procedure_history_loading').hide()
        $('#procedure_history_empty').show()
      }
      // Set up history tab click handler to fetch if not already loaded
      $('#procedure_history_tab').off('shown.bs.tab').on('shown.bs.tab', () => {
        const historyContainer = $('#procedure_history_data')
        const historyEmpty = $('#procedure_history_empty')
        if (!historyContainer.is(':visible') && !historyEmpty.is(':visible')) {
          this.fetchAndLoadHistory(procedureCode, teethPosition)
        }
      })
    } else {
      console.log('Hiding history tab - showHistoryTab:', showHistoryTab, 'procedureCode:', procedureCode, 'teethPosition:', teethPosition)
      $('#procedure_modal_tabs').hide()
      // Make sure details tab is active
      $('#procedure_details_tab').tab('show')
    }

    $('#procedure_modal_date_lbl').text(dateLabel)
    $('#procedure_modal_doctor_cost_lbl').text(doctorCostLabel)
    $('#procedure_modal_estimate_cost_lbl').text(estimateCostLabel)

    $('#procedure_modal_insurtion_date').val(insurtionDate || '')

    // Check if defaultPrice is valid
    const validDefaultPrice = !isNaN(parseFloat(defaultPrice))

    // Check if doctorCost/estimateCost is defined and not null (allow 0)
    // If empty, fallback to defaultPrice if valid
    const finalDocCost = (doctorCost !== undefined && doctorCost !== null && doctorCost !== '') ? doctorCost : (validDefaultPrice ? defaultPrice : '')
    const finalEstCost = (estimateCost !== undefined && estimateCost !== null && estimateCost !== '') ? estimateCost : (validDefaultPrice ? defaultPrice : '')

    $('#procedure_modal_doctor_cost').val(finalDocCost)
    $('#procedure_modal_estimate_cost').val(finalEstCost)

    // Show/hide images section based on whether imagesHtml is provided
    if (imagesHtml && imagesHtml.trim() !== '') {
      $('#procedure_modal_images').html(imagesHtml).show()
    } else {
      $('#procedure_modal_images').html('').hide()
    }

    // Calculate and fill patient share and net value    // Show/hide tabs based on showHistoryTab flag
    console.log('showProcedureModal called with:', {
      doctorCost: doctorCost,
      estimateCost: estimateCost,
      coverageRate: coverageRate,
      defaultPrice: defaultPrice,
      isBlocked: isBlocked,
      disableAllFields: disableAllFields,
      allowImagesOnly: allowImagesOnly,
      showSaveButton: showSaveButton,
      onSave: onSave,
      showHistoryTab: showHistoryTab,
      procedureCode: procedureCode,
      teethPosition: teethPosition,
      historyData: historyData,
      showAddNewButton: showAddNewButton,
      isAttached: isAttached
    })
    const docCostVal = parseFloat(finalDocCost) || 0
    const eCostVal = parseFloat(finalEstCost) || 0
    const covRateVal = parseFloat(coverageRate) || 0

    // Calculate patient share (insurance covered amount) and net value (patient pays)
    const defPriceVal = parseFloat(defaultPrice) || 0
    // Patient share = amount covered by insurance (defaultPrice * coverage_rate / 100)
    const patientShare = defPriceVal * (covRateVal / 100.0)
    // Net value = amount patient pays out of pocket (defaultPrice - patient share)
    const netValue = defPriceVal - patientShare

    $('#procedure_modal_patient_share').val(patientShare.toFixed(2))
    $('#procedure_modal_net_value').val(netValue.toFixed(2))

    // Check if procedure is blocked
    const procedureIsBlocked = (isBlocked === true || isBlocked === 'true')

    // Disable/Enable inputs based on context
    if (disableAllFields) {
      // Completely disable all fields (for read-only mode or locked procedures)
      $('#procedure_modal_estimate_cost').attr('disabled', 'disabled').attr('readonly', 'readonly')
      $('#procedure_modal_doctor_cost').attr('disabled', 'disabled').attr('readonly', 'readonly')
      $('#procedure_modal_insurtion_date').attr('disabled', 'disabled').attr('readonly', 'readonly')
    } else if (gon.user_type === 'doctor') {
      // For doctors adding/editing: allow date only, disable doctor cost and hide estimate cost
      $('#procedure_modal_estimate_cost').attr('disabled', 'disabled').attr('readonly', 'readonly')
      $('#procedure_modal_doctor_cost').attr('disabled', 'disabled').attr('readonly', 'readonly')
      // For new insertions, disable date field (it's set to today automatically)
      if (isNewInsertion) {
        $('#procedure_modal_insurtion_date').attr('disabled', 'disabled').attr('readonly', 'readonly')
      } else {
        $('#procedure_modal_insurtion_date').removeAttr('disabled').removeAttr('readonly')
      }
    } else {
      // For admins: doctor cost always disabled, estimate cost hidden (values set by model)
      $('#procedure_modal_estimate_cost').attr('disabled', 'disabled').attr('readonly', 'readonly')
      $('#procedure_modal_doctor_cost').attr('disabled', 'disabled').attr('readonly', 'readonly')
      // For new insertions, disable date field (it's set to today automatically)
      if (isNewInsertion) {
        $('#procedure_modal_insurtion_date').attr('disabled', 'disabled').attr('readonly', 'readonly')
      } else {
        $('#procedure_modal_insurtion_date').removeAttr('disabled').removeAttr('readonly')
      }
    }

    // Always hide estimate cost field (values are set automatically by model from procedure_default_price)
    $('#procedure_modal_estimate_cost').closest('.form-group').hide()

    // Handle save button and image upload button visibility
    if (allowImagesOnly) {
      // Locked procedure: hide save button, enable image upload only if creator matches
      $('#procedure_modal_save_btn').attr('disabled', 'disabled').addClass('btn-secondary').removeClass('btn-primary').hide()
      $('#procedure_modal_images button').removeAttr('disabled').show()
    } else if (showSaveButton === false) {
      // Read-only mode: hide save button and disable image upload
      $('#procedure_modal_save_btn').attr('disabled', 'disabled').addClass('btn-secondary').removeClass('btn-primary').hide()
      $('#procedure_modal_images button').attr('disabled', 'disabled').hide()
    } else {
      // Normal mode: show save button and enable image upload
      $('#procedure_modal_save_btn').removeAttr('disabled').removeClass('btn-secondary').addClass('btn-primary').show()
      $('#procedure_modal_images button').removeAttr('disabled')
    }

    $('#procedure_modal_save_btn').off('click').on('click', () => {
      const iDate = $('#procedure_modal_insurtion_date').val()
      const dCost = $('#procedure_modal_doctor_cost').val()
      const eCost = $('#procedure_modal_estimate_cost').val()

      if (!iDate || !dCost) return;

      if (typeof onSave === 'function') {
        onSave({ value: { insurtionDate: iDate, doctorCost: dCost, estimateCost: eCost } })
      }
      this.currentTeethNo = null
      $('#procedureEditModal').modal('hide')
    })

    $('#procedureEditModal').off('hidden.bs.modal').on('hidden.bs.modal', () => {
      if (this.currentTeethNo !== null) {
        const link = document.querySelector(`.link_${this.currentTeethNo}`)
        if (link) {
          const colored = link.querySelector('.color')
          if (colored) {
            colored.classList.add("black-white")
            colored.classList.remove("color")
          }
        }
        const spinner = document.querySelector(`.spinner-proc-${this.currentTeethNo}`)
        if (spinner) spinner.style.display = "none"
        this.isSaving = false
        this.currentTeethNo = null
      }
    })

    // Show/Hide Add New Insertion button and handle approval workflow for doctors
    const addNewBtn = $('#procedure_modal_add_new_btn')
    if (showAddNewButton) {
      if (gon.user_type === 'admin') {
        // Admin: show normal button
        addNewBtn.show()
          .removeClass('btn-success btn-secondary')
          .addClass('btn-info')
          .prop('disabled', false)
          .text(gon.locale === 'ar' ? 'إضافة إجراء جديد' : 'Add New Insertion')
        
        addNewBtn.off('click').on('click', () => {
          this.addNewInsertion(procedureCode, teethPosition, {
            date: dateLabel,
            doctorCost: doctorCostLabel,
            estimateCost: estimateCostLabel
          }, coverageRate, defaultPrice, isBlocked, isAttached)
        })
      } else if (gon.user_type === 'doctor') {
        // Doctor: show button
        addNewBtn.show()
        
        if (isBlocked) {
          // Blocked procedure: requires approval workflow
          // Set initial state while fetching approval status
          addNewBtn.removeClass('btn-success btn-secondary')
            .addClass('btn-info')
            .prop('disabled', false)
            .text(gon.locale === 'ar' ? 'طلب موافقة لإضافة إجراء جديد' : 'Request Approval for New Insertion')
          
          // Fetch approval status to show correct button state
          this.fetchApprovalStatus(procedureCode, teethPosition, (approval) => {
            if (!approval || (approval.approval_status === true && approval.is_proceeded === true)) {
              // No approval request exists OR approval was used (approved and proceeded)
              // Show "Request Approval" button
              addNewBtn.removeClass('btn-success btn-secondary')
                .addClass('btn-info')
                .prop('disabled', false)
                .text(gon.locale === 'ar' ? 'طلب موافقة لإضافة إجراء جديد' : 'Request Approval for New Insertion')
              
              addNewBtn.off('click').on('click', () => {
                this.requestApprovalForNewInsertion(procedureCode, teethPosition, addNewBtn)
              })
            } else if (approval.approval_status === false && approval.is_proceeded === false) {
              // Pending approval
              addNewBtn.removeClass('btn-info btn-success')
                .addClass('btn-secondary')
                .prop('disabled', true)
                .text(gon.locale === 'ar' ? 'في انتظار الموافقة' : 'Waiting for Approval')
              
              addNewBtn.off('click')
            } else if (approval.approval_status === false && approval.is_proceeded === true) {
              // Rejected
              addNewBtn.removeClass('btn-info btn-success')
                .addClass('btn-secondary')
                .prop('disabled', true)
                .text(gon.locale === 'ar' ? 'مرفوض' : 'Rejected')
              
              addNewBtn.off('click')
            } else if (approval.approval_status === true && approval.is_proceeded === false) {
              // Approved and not yet used
              addNewBtn.removeClass('btn-info btn-secondary')
                .addClass('btn-success')
                .prop('disabled', false)
                .text(gon.locale === 'ar' ? 'موافق عليه، إضافة جديد' : 'Approved, Add New')
              
              addNewBtn.off('click').on('click', () => {
                this.addNewInsertion(procedureCode, teethPosition, {
                  date: dateLabel,
                  doctorCost: doctorCostLabel,
                  estimateCost: estimateCostLabel
                }, coverageRate, defaultPrice, isBlocked, isAttached)
              })
            }
          })
        } else {
          // Non-blocked procedure: no approval needed, add directly
          addNewBtn.removeClass('btn-secondary btn-info')
            .addClass('btn-success')
            .prop('disabled', false)
            .text(gon.locale === 'ar' ? 'إضافة إجراء جديد' : 'Add New Insertion')
          
          addNewBtn.off('click').on('click', () => {
            this.addNewInsertion(procedureCode, teethPosition, {
              date: dateLabel,
              doctorCost: doctorCostLabel,
              estimateCost: estimateCostLabel
            }, coverageRate, defaultPrice, isBlocked, isAttached)
          })
        }
      } else {
        addNewBtn.hide()
      }
    } else {
      addNewBtn.hide()
    }

    $('#procedureEditModal').modal('show')
  }

  addNewInsertion(procedureCode, teethPosition, labels, coverageRate, defaultPrice, isBlocked, isAttached) {
    console.log('addNewInsertion called with:', { procedureCode, teethPosition, coverageRate, defaultPrice, isBlocked, isAttached })
    console.log('Labels:', labels)
    
    // Ensure we have valid coverage rate and default price
    const validCoverageRate = parseFloat(coverageRate) || 0
    const validDefaultPrice = parseFloat(defaultPrice) || 0
    console.log('Parsed values:', { validCoverageRate, validDefaultPrice })
    Swal.fire({
      title: gon.locale === 'ar' ? 'هل أنت متأكد من إضافة إجراء جديد؟' : 'Are you sure you want to add a new insertion?',
      text: gon.locale === 'ar' ? "سيتم إضافة إجراء جديد لنفس السن" : "A new procedure will be added for the same tooth",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: gon.confirm,
      cancelButtonText: gon.cancel
    }).then((result) => {
      if (result.isConfirmed) {
        const $modal = $('#procedureEditModal')

        // Handler for when modal is fully hidden
        const handleHidden = () => {
          // Unbind the event listener so it doesn't fire again
          $modal.off('hidden.bs.modal', handleHidden)

          // Prepare data for new insertion
          // We use -1 as procId (insertion id) to indicate new insertion
          // But we need the procedure code (e.g. "TEST") passed as procedureCode
          const no = `${teethPosition}_${procedureCode}`

          // Call setInsuredProcedure to open modal for new insertion
          // We pass empty history and oldProc as it's a new one
          // Pass defaultPrice as initial doctorCost for auto-fill
          // Pass today's date from server for insertionDate, then isAttached
          const todayDate = gon.today_date || ''
          console.log('Calling setInsuredProcedure with:', { no, coverageRate: validCoverageRate, defaultPrice: validDefaultPrice, isAttached, todayDate })
          this.setInsuredProcedure(no, -1, labels, [], "", validDefaultPrice, "", validCoverageRate, validDefaultPrice, todayDate, isAttached)
        }

        // Bind the event listener
        $modal.on('hidden.bs.modal', handleHidden)

        // Close current modal
        $modal.modal('hide')
      }
    })
  }

  fetchAndLoadHistory(procedureCode, teethPosition) {
    const historyLoading = $('#procedure_history_loading')
    const historyEmpty = $('#procedure_history_empty')

    historyLoading.show()
    historyEmpty.hide()

    $.ajax({
      type: "get",
      url: "/admin/procedures/get/history",
      dataType: "json",
      beforeSend: (xhr) => { xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content')) },
      data: {
        insured_number: gon.insured_number,
        procedure_code: procedureCode,
        teeth_position: teethPosition,
        doctor_id: gon.doctor_id,
        locale: gon.locale
      },
      success: (result) => {
        if (result.success) {
          this.loadProcedureHistory(procedureCode, teethPosition, result.history || [])
        } else {
          historyLoading.hide()
          historyEmpty.show()
        }
      },
      error: () => {
        historyLoading.hide()
        historyEmpty.show()
      }
    })
  }

  loadProcedureHistory(procedureCode, teethPosition, historyData) {
    const historyContainer = $('#procedure_history_data')
    const historyLoading = $('#procedure_history_loading')
    const historyEmpty = $('#procedure_history_empty')

    // Hide empty message
    historyEmpty.hide()
    historyLoading.hide()

    if (historyData && historyData.length > 0) {
      // Build history cards
      let historyHtml = '<div class="row">'
      historyData.forEach(item => {
        const approvalStatusText = item.approval_status ? (gon.locale === 'ar' ? 'موافق عليه' : 'Approved') : (gon.locale === 'ar' ? 'غير موافق عليه' : 'Not Approved');
        const approvalStatusBadgeClass = item.approval_status ? 'badge-success' : 'badge-warning';
        const doctorApprovalStatusText = item.doctor_approval_status ? (gon.locale === 'ar' ? 'موافق عليه' : 'Approved') : (gon.locale === 'ar' ? 'قيد الانتظار' : 'Pending');

        historyHtml += `
          <div class="col-12 col-sm-6 mb-2">
            <div class="card border h-100">
              <div class="card-body d-flex align-items-center p-2">
                <div class="${gon.locale === 'ar' ? 'ml-2' : 'mr-2'}">
                   <img src="${item.tooth_image_path}" class="img-fluid" style="height: 45px; width: 45px;" alt="Tooth">
                </div>
                <div class="w-100">
                  <div class="d-flex justify-content-between align-items-start mb-1">
                    <h5 class="card-title mb-0" style="font-size: 0.875rem; line-height: 1.2;">${item.procedure_name || '---'}</h5>
                    <span class="badge ${approvalStatusBadgeClass}" style="font-size: 0.7rem; padding: 0.15rem 0.4rem;">${approvalStatusText}</span>
                  </div>
                  
                  <p class="card-text text-muted mb-1" style="font-size: 0.75rem;">
                    <i class="fe fe-user ${gon.locale === 'ar' ? 'ml-1' : 'mr-1'}" style="font-size: 0.7rem;"></i> ${item.doctor_name}
                  </p>
                  
                  <div class="d-flex justify-content-between align-items-center">
                    <p class="card-text text-muted mb-0" style="font-size: 0.75rem;">
                      <i class="fe fe-calendar ${gon.locale === 'ar' ? 'ml-1' : 'mr-1'}" style="font-size: 0.7rem;"></i> ${item.insertion_date}
                    </p>
                    <span class="font-weight-bold text-primary" style="font-size: 0.875rem;">${item.doctor_cost}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        `
      })
      historyHtml += '</div>'

      historyContainer.html(historyHtml).show()
      historyLoading.hide()
    } else {
      historyContainer.hide()
      historyLoading.hide()
      historyEmpty.show()
    }
  }

  buildHistoryListHtml(oldProc, history) {
    let items = []
    if (Array.isArray(oldProc)) {
      if (Array.isArray(oldProc[0])) {
        items = oldProc[0]
      } else {
        items = oldProc
      }
    }
    if (!items || items.length === 0 || items[0] === '' || items[0] === undefined) {
      items = ['---']
    }
    const hist = history ? history : ''
    return hist + '<br/>' + `<ul>${items.map(item => `<li>${item}</li>`).join('')}</ul>`
  }

  deleteConfirmedProcedure(event) {
    event.preventDefault()
    const data = event.params

    console.log('deleteConfirmedProcedure data:', data)

    // Check if procedure requires images
    const requiresImages = (data.isAttached === true || data.isAttached === 'true')

    const labels = {
      date: data.dateLbl,
      doctorCost: data.doctorCostLbl,
      estimateCost: data.estimateCostLbl
    }

    // Function to open modal with history data
    const openModalWithHistory = (historyData, showHistoryTab) => {
      // For doctors, always show as read-only with "Add New Insertion" button
      const isDoctor = gon.user_type === 'doctor'
      
      if (!requiresImages) {
        // Procedure doesn't require images - show modal without images
        this.showProcedureModal({
          dateLabel: labels.date,
          doctorCostLabel: labels.doctorCost,
          estimateCostLabel: labels.estimateCost,
          insurtionDate: data.insertionDate,
          doctorCost: data.doctorCost,
          estimateCost: data.estimateCost,
          imagesHtml: '',
          coverageRate: data.coverageRate,
          defaultPrice: data.defaultPrice,
          isBlocked: data.isBlocked || false,
          disableAllFields: isDoctor,
          showSaveButton: !isDoctor,
          procedureCode: data.procId,
          teethPosition: data.teethPos,
          showAddNewButton: true,
          isAttached: requiresImages,
          showHistoryTab: showHistoryTab,
          historyData: historyData,
          onSave: (result) => {
            this.isSaving = false
            this.updateInsuredProcedure(data.insurtionId, result)
          }
        })
      } else {
        // Procedure requires images - fetch and show images
        // Construct the combined format "teethPos_procCode" that getProcedureInsurtionImages expects
        const combinedNo = `${data.teethPos}_${data.procId}`
        this.getProcedureInsurtionImages(combinedNo, data.insurtionId, labels,
          data.insertionDate, data.doctorCost, data.estimateCost, data.coverageRate, data.defaultPrice, data.isBlocked || false, requiresImages, showHistoryTab, historyData)
      }
    }

    // Fetch history if procedure is blocked (or just fetch it anyway to check)
    // We reuse the logic from checkAndShowHistoryTab but adapted
    $.ajax({
      type: "get",
      url: "/admin/procedures/get/history",
      data: {
        insured_number: gon.insured_number,
        procedure_code: data.procId,
        teeth_position: data.teethPos,
        doctor_id: gon.doctor_id,
        locale: gon.locale
      },
      success: (response) => {
        if (response.success) {
          openModalWithHistory(response.history, response.show_history_tab)
        } else {
          openModalWithHistory([], false)
        }
      },
      error: () => {
        openModalWithHistory([], false)
      }
    })
  }

  procApproval(event) {
    event.preventDefault()
    const data = event.params
    const { 
      no, procId, status, approvalId, isAttached, 
      coverageRate, defaultPrice, isBlocked,
      dateLbl, doctorCostLbl, estimateCostLbl,
      insertionDate, doctorCost, estimateCost
    } = data

    console.log('procApproval called with FULL data:', data)
    console.log('procApproval extracted:', { no, procId, status, approvalId, isAttached, coverageRate, defaultPrice, isBlocked, user_type: gon.user_type })

    // First, check if this is for a doctor and if this click refers to an EXISTING insertion id.
    // NOTE: `procId` may come as number (-1) or string ("-1") from Stimulus params.
    const hasExistingInsertionId = procId !== null && procId !== undefined && String(procId) !== '-1'

    if (gon.user_type === 'doctor' && hasExistingInsertionId) {
      // Check if procedure is blocked by fetching procedure insertion details
      $.ajax({
        type: "get",
        url: "/admin/procedures/get/uploaded_images",
        dataType: "json",
        beforeSend: (xhr) => { xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content')) },
        data: {
          procedure_id: procId,
          doctor_id: gon.doctor_id,
          locale: gon.locale
        },
        success: (result) => {
          if (result.success && result.is_blocked === false) {
            // Procedure is NOT blocked - directly show edit modal
            const idsData = no.split("_")
            const teethPos = idsData[0]
            const procCode = idsData[1]

            const labels = {
              date: dateLbl || gon.insertion_date || 'Date',
              doctorCost: doctorCostLbl || gon.one_teeth_require || 'Doctor Cost',
              estimateCost: estimateCostLbl || gon.estimate_cost || 'Estimate Cost'
            }

            // Check if procedure requires images
            const requiresImages = (isAttached === true || isAttached === 'true')

            // Check if we should show history tab for this procedure
            this.checkAndShowHistoryTab(procCode, teethPos, (showHistoryTab, historyData) => {
              const actualCoverageRate = parseFloat(coverageRate) || 0
              const actualDefaultPrice = parseFloat(defaultPrice) || 0
              
              console.log('Blocked procedure - Using values:', { actualCoverageRate, actualDefaultPrice, resultDoctorCost: result.doctor_cost })
              
              if (!requiresImages) {
                // No images required - show modal without images, all fields disabled
                this.showProcedureModal({
                  dateLabel: labels.date,
                  doctorCostLabel: labels.doctorCost,
                  estimateCostLabel: labels.estimateCost,
                  insurtionDate: result.insurtion_date || insertionDate || '',
                  doctorCost: result.doctor_cost || doctorCost || '',
                  estimateCost: result.estimate_cost || estimateCost || '',
                  imagesHtml: '',
                  coverageRate: actualCoverageRate,
                  defaultPrice: actualDefaultPrice,
                  isBlocked: false,
                  disableAllFields: true,
                  allowImagesOnly: false,
                  showSaveButton: false,
                  showAddNewButton: true,
                  isAttached: requiresImages,
                  showHistoryTab: showHistoryTab,
                  procedureCode: procCode,
                  teethPosition: teethPos,
                  historyData: historyData,
                  onSave: () => { } // No save for read-only
                })
              } else {
                // Images required - show modal with all fields disabled except image upload if creator matches
                const combinedNo = `${teethPos}_${procCode}`
                this.getProcedureInsurtionImages(combinedNo, procId, labels,
                  result.insurtion_date || insertionDate || '', result.doctor_cost || doctorCost || '', result.estimate_cost || estimateCost || '', actualCoverageRate, actualDefaultPrice, false, requiresImages, showHistoryTab, historyData)
              }
            })
          } else if (result.success && result.is_blocked === true) {
            // Procedure IS blocked - show modal with fields disabled (except image upload if creator matches)
            const idsData = no.split("_")
            const teethPos = idsData[0]
            const procCode = idsData[1]

            const labels = {
              date: gon.insertion_date || 'Date',
              doctorCost: gon.one_teeth_require || 'Doctor Cost',
              estimateCost: gon.estimate_cost || 'Estimate Cost'
            }

            // Check if current doctor is the creator
            const isCreator = result.doctor_id && gon.doctor_id && result.doctor_id === gon.doctor_id

            // Check if procedure requires images
            const requiresImages = (isAttached === true || isAttached === 'true')

            // Check if we should show history tab for this procedure
            this.checkAndShowHistoryTab(procCode, teethPos, (showHistoryTab, historyData) => {
              const actualCoverageRate = parseFloat(coverageRate) || 0
              const actualDefaultPrice = parseFloat(defaultPrice) || 0
              
              console.log('Blocked procedure - Using values:', { actualCoverageRate, actualDefaultPrice, resultDoctorCost: result.doctor_cost })
              
              if (!requiresImages) {
                // No images required - show modal without images, all fields disabled
                this.showProcedureModal({
                  dateLabel: labels.date,
                  doctorCostLabel: labels.doctorCost,
                  estimateCostLabel: labels.estimateCost,
                  insurtionDate: result.insurtion_date || insertionDate || '',
                  doctorCost: result.doctor_cost || doctorCost || '',
                  estimateCost: result.estimate_cost || estimateCost || '',
                  imagesHtml: '',
                  coverageRate: actualCoverageRate,
                  defaultPrice: actualDefaultPrice,
                  isBlocked: true,
                  disableAllFields: true,
                  allowImagesOnly: false,
                  showSaveButton: false,
                  showAddNewButton: true,
                  showHistoryTab: showHistoryTab,
                  procedureCode: procCode,
                  teethPosition: teethPos,
                  historyData: historyData,
                  isAttached: requiresImages,
                  onSave: () => { } // No save for read-only
                })
              } else {
                // Images required - show modal with all fields disabled except image upload if creator matches
                const combinedNo = `${teethPos}_${procCode}`
                this.getProcedureInsurtionImages(combinedNo, procId, labels,
                  result.insurtion_date || insertionDate || '', result.doctor_cost || doctorCost || '', result.estimate_cost || estimateCost || '', actualCoverageRate, actualDefaultPrice, true, requiresImages, showHistoryTab, historyData)
              }
            })
          } else {
            // Error or other case - show normal approval flow
            this.showApprovalFlow(status, no, procId, isAttached, approvalId)
          }
        },
        error: () => {
          // Error fetching details - show normal approval flow
          this.showApprovalFlow(status, no, procId, isAttached, approvalId)
        }
      })
    } else {
      // Not a doctor or no valid procId - show normal approval flow
      this.showApprovalFlow(status, no, procId, isAttached, approvalId)
    }
  }

  showApprovalFlow(status, no, procId, isAttached, approvalId) {
    if (status) {
      const idsData = no.split("_")
      Swal.fire({
        title: gon.approval_new_title,
        html: gon.approval_new_msg,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        confirmButtonText: gon.approval_new_confirm,
        cancelButtonText: gon.approval_new_cancel
      }).then((result) => {
        if (result.isConfirmed) {
          this.sendProceduralApproval(idsData[1], idsData[0])
        }
      })
    } else {
      this.checkApprovalStatus(no, procId, isAttached, approvalId)
    }
  }

  sendProceduralApproval(procCode, teethPos) {
    const data = {
      insured_number: gon.insured_number,
      doctor_id: gon.doctor_id,
      procedure_code: procCode,
      teeth_position: teethPos
    }

    $.ajax({
      type: "post",
      url: "/admin/procedures/approval/add",
      dataType: "json",
      beforeSend: (xhr) => { xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content')) },
      data: data,
      success: (result) => {
        if (result.success) {
          const link = document.querySelector(`.link_${teethPos}_${procCode}`)
          if (link) {
            link.dataset.insertionProcIdParam = -1
            link.dataset.insertionStatusParam = false
            link.dataset.insertionApprovalIdParam = result.id

            const lock = document.querySelector(`.lock-proc-${teethPos}_${procCode}`)
            if (lock) lock.innerHTML = '<h1 style="color: #007bff;filter: drop-shadow(1px -1px 0px black);"><i class="fe fe-info"></i></h1>'
          }

          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: result.msg,
            showConfirmButton: false,
            timer: 1800
          })
        }
      }
    })
  }

  addProcedureToCarousel(procedureCardHtml) {
    // Check if we have the old procedures carousel target
    if (!this.hasOldProceduresCarouselTarget) return

    // Hide "no data" message if it exists
    if (this.hasNoProceduresMessageTarget) {
      this.noProceduresMessageTarget.style.display = 'none'
    }

    const carousel = this.oldProceduresCarouselTarget

    // Check if owl carousel is initialized
    const owlData = $(carousel).data('owl.carousel')

    if (owlData) {
      // Owl carousel is initialized - add item dynamically
      $(carousel).trigger('add.owl.carousel', [$(procedureCardHtml)])
        .trigger('refresh.owl.carousel')
        .trigger('to.owl.carousel', [0, 300]) // Navigate to first item (newest)
    } else {
      // Owl carousel not initialized yet - just append the HTML
      carousel.insertAdjacentHTML('afterbegin', procedureCardHtml)
    }
  }

  updateProcedureInCarousel(procId, procedureCardHtml) {
    // Check if we have the old procedures carousel target
    if (!this.hasOldProceduresCarouselTarget) return

    const carousel = this.oldProceduresCarouselTarget

    // Check if owl carousel is initialized
    const owlData = $(carousel).data('owl.carousel')

    if (owlData) {
      // Owl carousel is initialized
      // Find the item containing this procedure (by looking for the link with proc_ins_id in URL)
      const $items = $(carousel).find('.owl-item')
      let foundIndex = -1

      $items.each(function (index, item) {
        const $link = $(item).find('a[href*="proc_ins_id=' + procId + '"]')
        if ($link.length > 0) {
          foundIndex = index
          return false // Break the loop
        }
      })

      if (foundIndex >= 0) {
        // Found the item - remove it and add the new one at the same position
        $(carousel).trigger('remove.owl.carousel', [foundIndex])
          .trigger('add.owl.carousel', [$(procedureCardHtml), foundIndex])
          .trigger('refresh.owl.carousel')
          .trigger('to.owl.carousel', [foundIndex, 300]) // Stay at the same position
      } else {
        // Item not found - add it as new (prepend to start)
        $(carousel).trigger('add.owl.carousel', [$(procedureCardHtml)])
          .trigger('refresh.owl.carousel')
          .trigger('to.owl.carousel', [0, 300])
      }
    } else {
      // Owl carousel not initialized - try to find and replace in DOM
      const $carousel = $(carousel)
      const $existingCard = $carousel.find('a[href*="proc_ins_id=' + procId + '"]').closest('.item')

      if ($existingCard.length > 0) {
        $existingCard.replaceWith(procedureCardHtml)
      } else {
        // Not found - add as new
        carousel.insertAdjacentHTML('afterbegin', procedureCardHtml)
      }
    }

    // Hide "no data" message if it exists
    if (this.hasNoProceduresMessageTarget) {
      this.noProceduresMessageTarget.style.display = 'none'
    }
  }

  fetchApprovalStatus(procedureCode, teethPosition, callback) {
    // Fetch approval status for a given procedure and tooth position
    $.ajax({
      type: "get",
      url: "/admin/procedures/approval/check_by_position",
      dataType: "json",
      beforeSend: (xhr) => { xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content')) },
      data: {
        insured_number: gon.insured_number,
        doctor_id: gon.doctor_id,
        procedure_code: procedureCode,
        teeth_position: teethPosition
      },
      success: (result) => {
        if (result.success && result.approval) {
          callback(result.approval)
        } else {
          callback(null)
        }
      },
      error: () => {
        callback(null)
      }
    })
  }

  requestApprovalForNewInsertion(procedureCode, teethPosition, buttonElement) {
    // Show confirmation dialog with the approval message
    Swal.fire({
      title: gon.approval_new_title || (gon.locale === 'ar' ? 'يتطلب الحصول على موافقة' : 'This Procedure needs approval'),
      html: gon.approval_new_msg || (gon.locale === 'ar' ? 'هل تريد طلب موافقة لإضافة إجراء جديد؟' : 'Do you want to request approval to add a new insertion?'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: gon.approval_new_confirm || (gon.locale === 'ar' ? 'نعم، أرسل الطلب' : 'Yes, send request'),
      cancelButtonText: gon.approval_new_cancel || (gon.locale === 'ar' ? 'إلغاء' : 'Cancel')
    }).then((result) => {
      if (result.isConfirmed) {
        // Send approval request
        $.ajax({
          type: "post",
          url: "/admin/procedures/approval/add",
          dataType: "json",
          beforeSend: (xhr) => { xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content')) },
          data: {
            insured_number: gon.insured_number,
            doctor_id: gon.doctor_id,
            procedure_code: procedureCode,
            teeth_position: teethPosition
          },
          success: (response) => {
            if (response.success) {
              // Update button to "Waiting for Approval" state
              $(buttonElement).removeClass('btn-info btn-success')
                .addClass('btn-secondary')
                .prop('disabled', true)
                .text(gon.locale === 'ar' ? 'في انتظار الموافقة' : 'Waiting for Approval')
                .off('click')
              
              Swal.fire({
                position: 'top-end',
                icon: 'success',
                title: gon.locale === 'ar' ? 'تم إرسال الطلب بنجاح' : 'Request sent successfully',
                showConfirmButton: false,
                timer: 1800
              })
            } else {
              Swal.fire({
                icon: 'error',
                title: gon.locale === 'ar' ? 'خطأ' : 'Error',
                text: gon.locale === 'ar' ? 'فشل إرسال الطلب' : 'Failed to send request'
              })
            }
          },
          error: () => {
            Swal.fire({
              icon: 'error',
              title: gon.locale === 'ar' ? 'خطأ' : 'Error',
              text: gon.locale === 'ar' ? 'حدث خطأ أثناء إرسال الطلب' : 'An error occurred while sending the request'
            })
          }
        })
      }
    })
  }

  checkApprovalStatus(no, procId, isAttached, approvalId) {
    // Get doctor_id - for doctors, use gon.doctor_id or current_doctor.email
    const doctorId = gon.doctor_id || (gon.user_type === 'doctor' ? gon.doctor_id : null)
    console.log('checkApprovalStatus called:', { no, procId, isAttached, approvalId, doctorId, gon_doctor_id: gon.doctor_id, user_type: gon.user_type })

    const data = {
      approval_id: approvalId,
      doctor_id: doctorId
    }
    $.ajax({
      type: "get",
      url: "/admin/procedures/approval/check",
      dataType: "json",
      beforeSend: (xhr) => { xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content')) },
      data: data,
      success: (result) => {
        if (result.status && result.admin != null) {
          if (result.is_proceeded && result.is_doctor_approved) {
            const idsData = no.split("_")
            Swal.fire({
              title: gon.approval_new_title,
              html: gon.approval_new_msg,
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              confirmButtonText: gon.approval_new_confirm,
              confirmButtonText: gon.approval_new_confirm,
              cancelButtonText: gon.approval_new_cancel
            }).then((res) => {
              if (res.isConfirmed) {
                this.sendProceduralApproval(idsData[1], idsData[0])
              }
            })
          } else if (result.is_proceeded) {
            // Trigger selectTeeth
            const link = document.querySelector(`.link_${no}`)
            // We can reuse the selectTeeth method but we need to pass an object that looks like an event or refactor selectTeeth
            // Let's mock the event
            const mockEvent = {
              preventDefault: () => { },
              currentTarget: link,
              params: {
                no: result.teeth_position + "_" + result.proc_code,
                procId: result.proc_id,
                isAttached: isAttached,
                // Fallback labels - assuming they are available globally or passed
                dateLbl: gon.insertion_date,
                estimateCostLbl: gon.estimate_cost,
                cancelLbl: gon.cancel,
                confirmLbl: gon.save_label,
                doctorCostLbl: gon.one_teeth_require,
                errMsg: gon.empty_fields
              }
            }
            this.selectTeeth(mockEvent)
          } else {
            const procCode = result.proc_code
            const teethPos = result.teeth_position
            console.log('Approval approved - showing confirmation dialog', { procCode, teethPos, no, procId })
            Swal.fire({
              icon: 'success',
              title: gon.locale === 'ar' ? 'تمت الموافقة على الإجراء, هل ترغب بعمل الإجراء الآن ؟' : 'The procedure has been approved. Do you want to perform it now?',
              showCancelButton: true,
              cancelButtonText: gon.cancel,
              confirmButtonText: gon.confirm
            }).then((res) => {
              if (res.isConfirmed) {
                console.log('User confirmed - proceeding with procedure insertion')
                const lock = document.querySelector(`.lock-proc-${no}`)
                if (lock) lock.style.display = "none"

                const lockPos = document.querySelector(`.lock-proc-${teethPos}_${procCode}`)
                if (lockPos) lockPos.innerHTML = '<h1 style="color: brown;filter: drop-shadow(1px -1px 0px black);"><i class="fe fe-lock"></i></h1>'

                const link = document.querySelector(`.link_${teethPos}_${procCode}`)
                if (link) {
                  const fakeColor = link.querySelector('.color-fake')
                  if (fakeColor) {
                    fakeColor.classList.add("color")
                    fakeColor.classList.remove("color-fake")
                  }
                }
                // Pass proper labels and ensure history check happens
                // Use the combined format "teethPos_procCode" for the id parameter
                const combinedNo = `${teethPos}_${procCode}`
                const labels = {
                  date: gon.insertion_date || 'Date',
                  doctorCost: gon.one_teeth_require || 'Doctor Cost',
                  estimateCost: gon.estimate_cost || 'Estimate Cost'
                }
                // Get coverage rate if available
                const coverageRate = 0 // Will be calculated on server
                console.log('Calling setInsuredProcedure with:', { combinedNo, procId, procCode, teethPos })
                this.setInsuredProcedure(combinedNo, procId, labels, [], "", 0, 0, coverageRate, 0, false)
              }
            })
          }
        } else if (!result.status && result.admin != null) {
          Swal.fire({
            icon: 'error',
            title: gon.locale === 'ar' ? 'تم رفض الإجراء من قبل الشركة' : 'The procedure was rejected by the company',
            showCancelButton: false,
            confirmButtonText: gon.confirm
          })
        } else {
          Swal.fire({
            icon: 'info',
            title: gon.locale === 'ar' ? 'طلب الإجراء قيد المراجعة' : 'The procedure request is under review',
            showCancelButton: false,
            confirmButtonText: gon.confirm
          })
        }
      }
    })
  }
}
